import React, {useEffect, useState} from 'react';

import './SignInButton.css';
import AppConfig from "../../AppConfig";

import AppleSignin from "react-apple-signin-auth";
import TOSModal from "../tos-modal/TOSModal";
import {AppleSignUpHandler} from "../../authentication/AuthFunctions";
import * as AuthActions from "../../store/actions/authActions";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";

const TAppleSignInWrapper = {
    // English
    "enUS": {
        'SIGN_IN': 'Sign in with Apple',
    },
    // Spanish
    "esMX": {
        'SIGN_IN': 'Acceder con Apple',
    }
}

const AppleSignInWrapper = ({ redirectUri, onClick }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()


    useEffect(() => {

    }, []);

    return <div style={{ display: 'flex', flexDirection: 'column' }}>
        <AppleSignin
            /** Auth options passed to AppleID.auth.init() */
            authOptions={{
                /** Client ID - eg: 'com.example.com' */
                clientId: 'app.tastee.webapp',
                /** Requested scopes, seperated by spaces - eg: 'email name' */
                scope: 'email name',
                redirectURI: redirectUri,
                /** Uses popup auth instead of redirection */
                usePopup: true
            }} // REQUIRED
            uiType="dark"
            className="apple-auth-btn"
            buttonExtraChildren={<div style={{ marginLeft: 8, fontSize: 18 }}>{TAppleSignInWrapper[AppConfig.lang].SIGN_IN}</div>}
            /** Extra controlling props */
            /** Called upon signin success in case authOptions.usePopup = true -- which means auth is handled client side */
            onSuccess={(signInResponse) => {
                console.log(signInResponse)

                onClick(signInResponse);
            }} // default = undefined
            /** Called upon signin error */
            onError={(error) => console.error(error)} // default = undefined
        />
    </div>
};

export default AppleSignInWrapper;
